import { type ReactNode, memo } from 'react';
import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { IconCheck, IconLayoutDashboard, IconMap } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from '../WorkspaceOnboardingPage.module.css';

interface SuccessContentProps {
  workspaceName: string;
  onGoToWorkspace: () => void;
  onGoToDashboard: () => void;
  isMobile?: boolean;
}

export const SuccessContent = memo(function SuccessContent({
  workspaceName,
  onGoToWorkspace,
  onGoToDashboard,
  isMobile = false,
}: SuccessContentProps): ReactNode {
  const { t } = useTranslation();

  const ButtonContainer = isMobile ? Stack : Group;
  const containerProps = isMobile ? { gap: 'sm' as const, w: '100%' } : {};

  return (
    <Stack align="center" gap="xl">
      <IconCheck size={64} className={styles.successIcon} />
      <Title order={2} ta="center">
        {t('workspace.onboarding.success.title')}
      </Title>
      <Text c="dimmed" ta="center" size="lg">
        {t('workspace.onboarding.success.description', { name: workspaceName })}
      </Text>
      <ButtonContainer {...containerProps}>
        <Button
          size="lg"
          fullWidth={isMobile}
          leftSection={<IconMap size={20} />}
          onClick={onGoToWorkspace}
        >
          {t('workspace.onboarding.success.goToWorkspace')}
        </Button>
        <Button
          size="lg"
          fullWidth={isMobile}
          variant="outline"
          leftSection={<IconLayoutDashboard size={20} />}
          onClick={onGoToDashboard}
        >
          {t('workspace.onboarding.success.goToDashboard')}
        </Button>
      </ButtonContainer>
    </Stack>
  );
});
